import {AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup} from '@angular/forms';

export class FormUtils {

    public static setFormValueWithoutEmitEvent(form: UntypedFormGroup, key: string, value: any) {
        this.setValueWithoutEmitEvent(form.controls[key], value);
    }

    public static resetEmptyValuesWithoutEmitEvent(form: UntypedFormGroup, ...properties: string[]) {
        properties.forEach(key => {
            if (form.get(key).value === '') {
                this.resetValueWithoutEmitEvent(form, key);
            }
        });
    }

    public static resetAllEmptyValuesWithoutEmitEvent(form: UntypedFormGroup) {
        Object.keys(form.controls).forEach(key => {
            if (form.get(key).value === '') {
                this.resetValueWithoutEmitEvent(form, key);
            }
        });
    }

    private static resetValuesWithoutEmitEvent(form: UntypedFormGroup) {
        Object.keys(form.controls).forEach(key => {
            this.resetValueWithoutEmitEvent(form, key);
        });

    }

    private static resetValueWithoutEmitEvent(form: UntypedFormGroup, key: string) {
        if (form.controls[key] instanceof UntypedFormGroup) {
            const formGroup: UntypedFormGroup = form.controls[key] as UntypedFormGroup;
            this.resetValuesWithoutEmitEvent(formGroup);
        } else {
            this.setValueWithoutEmitEvent(form.controls[key], undefined);
        }
    }

    public static setValueWithoutEmitEvent(control: AbstractControl, value: any) {
        control.patchValue(value, {onlySelf: true, emitEvent: false});
    }

    public static isRequiredField(control: AbstractControl) {
        if (!control.validator) {
            return false;
        }
        const validator = control.validator({} as AbstractControl);
        return (validator && validator.required);
    }

    public static clearFormArray(formArray: UntypedFormArray) {
        while (formArray.length !== 0) {
            formArray.removeAt(0);
        }
    }

    public static removeAllControls(formGroup: UntypedFormGroup) {
        Object.keys(formGroup.controls).forEach(controlName => {
            formGroup.removeControl(controlName);
        });
    }

    public static collectErrors(control: AbstractControl): any | null {
        if (control instanceof UntypedFormControl) {
            // Return FormControl errors or null
            return control.errors ?? null;
        }

        if (control instanceof UntypedFormGroup || control instanceof UntypedFormArray) {
            const groupErrors = control.errors;
            // Form group or form array can contain errors itself, in that case add them
            const formErrors = groupErrors ? groupErrors : {};
            Object.keys(control.controls).forEach(key => {
                // Recursive call of the FormGroup fields
                const error = this.collectErrors(control.get(key));
                if (error !== null) {
                    // Only add error if not null
                    formErrors[key] = error;
                }
            });
            // Return FormGroup errors or null
            return Object.keys(formErrors).length > 0 ? formErrors : null;
        }
    }
}
